var _circle, _circle2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSucessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2482,
    cy: 32.6037,
    r: 16.7517,
    fill: "#AFFFD1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1074,
    cy: 18.1074,
    r: 16.1074,
    stroke: "#16161E",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 6.75845,
    y2: -1.5,
    transform: "matrix(0.715187 0.698933 -0.715187 0.698933 11.02 17.7485)",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 11.8477,
    y2: -1.5,
    transform: "matrix(0.715187 -0.698933 0.715187 0.698933 16.9868 23.5703)",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSucessIcon);
export default __webpack_public_path__ + "static/media/modalSucessIcon.cacfd28fd86e55b05b2e30174abf4044.svg";
export { ForwardRef as ReactComponent };